import { Fragment } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Loader } from '@hopskipdrive/react-components';
import { uniqueId } from 'lodash';

import { useAuth } from '../contexts/AuthContext';
import NotFound from '../pages/NotFound';

function RoutesRenderer({ routesContext, routesConfig }): JSX.Element {
  const { user } = useAuth();

  if (!user) {
    window.location.assign(`https://${window.env?.ALERTS_BASE_DOMAIN}`);

    return <Loader />;
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/alerts" />} />
      {routesContext.map(({ consumerRoutes, contextProvider }) => {
        const ContextProvider = contextProvider || Fragment;
        const routesForContext = routesConfig.filter((routeConfig) => consumerRoutes.indexOf(routeConfig.path) !== -1);

        return routesForContext.map(({ path, component: Component }) => (
          <ContextProvider key={uniqueId()}>
            <Route key={uniqueId()} path={path} element={<Component />} />
          </ContextProvider>
        ));
      })}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default RoutesRenderer;
